module.exports = __webpack_public_path__ + "static/img/about13.57a52e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about13.png
// module id = GT+i
// module chunks = 1